import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import useBankVerificationPageLogic from './hooks/useBankVerificationPageLogic'
import ButtonCancelApplication from 'components/Buttons/ButtonCancelApplication/ButtonCancelApplication'
import Summary from 'components/Summary/Summary'
import useIsMobile from 'common/hooks/useIsMobile'
import { AppLinks } from 'enviroment/AppLinks'
import useTextContents from 'common/hooks/useTextContents'
import Button, { AppButtonTypes } from 'components/Buttons/ButtonBase/Button'
import { changeApplicationStep } from 'store/ApplicationSlice/ApplicationSlice'
import { PAGE_STEPER_STAGES } from 'components/Navbar/pageSteps'


import './BankVerificationPageStyles.scss'


/**
 * Komponent obsługujący weryfikację w banku (KONTOMATIK) - (etap AIS w procesie) 
*/
const BankVerificationPage = (): JSX.Element => {
  const navigate = useNavigate()
  const { isKontomatikWorking, HTML_KONTOMATIK_DIV_ID, isAdditionalVerificationMethodsAvailable } = useBankVerificationPageLogic()
  const isMobileDevice = useIsMobile()
  const bankVerificationPageTextContents = useTextContents()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(changeApplicationStep(PAGE_STEPER_STAGES.BANK_VERIFICATION))
  }, [])

  return (
    <div className='bank-verification-page-outer-wrapper'>
      <section className='bank-verification-page-inner-wrapper'>
        <div className='bank-verification-page-heading-text-wrapper'>
          <h1 className='bank-verification-page-header' >{bankVerificationPageTextContents('bankVerificationPage.header')}</h1>
          <div className='bank-verification-page-description'>
              <p>{bankVerificationPageTextContents('bankVerificationPage.mainContent')}</p>
          </div>
          </div>
          {
            isKontomatikWorking
            ? <div className='bank-verification-kontomatik' id={HTML_KONTOMATIK_DIV_ID} />
            : <div className='bank-verification-kontomatik-error'>{bankVerificationPageTextContents('bankVerificationPage.kontomatikError')}</div>
          }
          {
            isAdditionalVerificationMethodsAvailable &&
            <Button 
              style={{ textTransform: 'none' }}
              buttonContent={bankVerificationPageTextContents('buttons.chooseAnotherVerificationMethod')}
              className='page-application-prev-button'
              onClick={() => navigate(AppLinks.chooseVerificationMethod)}
            />
          }
          <ButtonCancelApplication className='bank-verification-page-cancel-application-button'/>
      </section>
      {!isMobileDevice && <Summary isExtended={true} />}
    </div>
  )
}

export default BankVerificationPage